import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader
} from '@clientbase/clientbase-library'
import { Typography } from '@mui/material'

import StartOfferCard from './StartOfferCard'
import * as S from './styles'

interface ModalNewPlansSmallProps {
  open: boolean
  onClose: () => void
}

const ModalNewPlansSmall = ({ open, onClose }: ModalNewPlansSmallProps) => {
  return (
    <Modal
      width="92vw"
      height="auto"
      maxWidth="960px"
      maxHeight="90vh"
      handleClose={onClose}
      open={open}
      size="extraLarge"
    >
      <ModalBody>
        <ModalHeader onClose={onClose} sx={{ border: 'none' }}>
          <Typography variant="lgBold">
            Mais recursos e cobranças grátis
          </Typography>
        </ModalHeader>

        <ModalContent>
          <S.Wrapper>
            <S.Subtitle>
              <p>
                Você já deve ter visto que lançamos novos planos, com recursos
                incríveis e <strong>cobranças grátis</strong>, né?
              </p>
              <p>
                Por isso, desde <strong>1º de agosto</strong>, não temos mais o
                plano Free da Base de Clientes e você precisa fazer um upgrade.
              </p>
              <p>
                E, para valorizar a nossa parceria, preparamos uma{' '}
                <strong>condição especial</strong> para você continuar
                simplificando a sua operação:
              </p>
            </S.Subtitle>

            <S.CardsRow>
              <StartOfferCard onCheckout={onClose} />
            </S.CardsRow>
          </S.Wrapper>
        </ModalContent>
      </ModalBody>
    </Modal>
  )
}

export default ModalNewPlansSmall
